import { withAuthGate } from '@sunrise-ui/composites';
import IntroductionView from '@templates/IntroductionView';
import React from 'react';

function DeniedIntroScreen() {
  return <IntroductionView />;
}

export default withAuthGate(DeniedIntroScreen);
